import type { DeepPartial } from '@luna/utils-ts';

import type { ContactDataManagementFeatureConfig } from './type';

export const contactDataManagement: DeepPartial<ContactDataManagementFeatureConfig> = {
    showEmptyBusinessContacts: true,
    newBusinessContactEntryAllowed: true,
    operationAgnosticSigningEnabled: true,
    showEmptyPersonalContacts: false,
};
